import React from 'react'

export default function IconShieldTickOutline({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'

    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M16.6663 10.8335C16.6663 15.0002 13.7497 17.0835 10.283 18.2919C10.1015 18.3534 9.90429 18.3505 9.72467 18.2835C6.24967 17.0835 3.33301 15.0002 3.33301 10.8335V5.00021C3.33301 4.7792 3.42081 4.56724 3.57709 4.41096C3.73337 4.25468 3.94533 4.16688 4.16634 4.16688C5.83301 4.16688 7.91634 3.16688 9.36634 1.90021C9.54289 1.74938 9.76747 1.6665 9.99967 1.6665C10.2319 1.6665 10.4565 1.74938 10.633 1.90021C12.0913 3.17521 14.1663 4.16688 15.833 4.16688C16.054 4.16688 16.266 4.25468 16.4223 4.41096C16.5785 4.56724 16.6663 4.7792 16.6663 5.00021V10.8335Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.5 10.0002L9.16667 11.6668L12.5 8.3335'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
